import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';

import ConfirmCancel from './confirm-cancel';
import { v4 as uuidv4 } from 'uuid';

import delete_icon from 'assets/img/delete.svg';
import { CheckBox } from '../../../components/checkboxes/check-box';
import RFSSignoffModal from './rfs-signoff-confirm-modal';
import * as UnitHelper from '../../../helper/unit-helper';

class TemplateEOCView extends React.Component {

    static propTypes = {
      projectId: PropTypes.string,
      templateId: PropTypes.string,
      getCustomTemplateDetail: PropTypes.func,
      isOpen: PropTypes.bool,
      onClose: PropTypes.func,
      customTemplateList: PropTypes.object,
      onEditCustomTemplate: PropTypes.func,
      isSystemTemplate: PropTypes.bool,
      getDefaultTemplate: PropTypes.func
    }

    constructor(props) {
      super(props);

      this.state = {
        name: 'Untitled template',
        sections: [
          {id: uuidv4(),
          title: 'Are you sure you want to allow RFS SignOff without the WO being resolved or closed?',
          type: 1,
          value: false,
          items:[]}
        ],
        disclaimer: '',
        openConfirmModal: false,
        isSave: false,
        openRFSSignoffConfirmModal:false,
        isAllowRfsSignoff:false
      };
    }

    componentDidMount() {
      this.getCustomTemplateDetail();
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.customTemplateList !== nextProps.customTemplateList) {
        this.setState({
          id: nextProps.customTemplateList.id,
          name: nextProps.customTemplateList.name,
          sections: nextProps.customTemplateList.sections,
          disclaimer: nextProps.customTemplateList.disclaimerText !== null ? nextProps.customTemplateList.disclaimerText : '',
          isAllowRfsSignoff:nextProps.customTemplateList.EofStatus
        });
      }
    }

    onClose = () => {
      this.props.onClose();
    }

    onRFSSignoffConfirm = () =>{
      this.setState({
        openRFSSignoffConfirmModal: false
      });
    }
 
    onCloseAfterEdit = () => {
      this.props.onClose();
      this.props.getDefaultTemplate();
    }

    onCancelConfirmModal = () => {

      let { sections} = this.state;
      var index = sections.findIndex((obj,index) => obj.id === sections[index].id);
      sections[index].value = false;
        this.setState({openRFSSignoffConfirmModal: false,  sections,openConfirmModal: false,openModalConfirm: !this.state.openModalConfirm, });
    }

    getCustomTemplateDetail() {
      this.props.getCustomTemplateDetail({
        projectId: this.props.projectId,
        templateId: this.props.templateId
      });
    }

    isInvalidTemplate() {
      const { sections } = this.state;

      if (sections.length === 0) {
        return true;
      }

      if (sections.some(s => !s.items.some(i => i.content && i.content.length > 0))) {
        return true;
      }

      return false;
    }

    toolTipDisclaimer() {
      return (
        <Tooltip className='in tooltip-siteone' id='disable-go-to'>
          <span>This disclaimer is put right above the signature section in the form.</span>
        </Tooltip>
      );
    }

    onAddNewSectionBtnClick = () => {
      let { sections } = this.state;

      sections.push({
        id: uuidv4(),
        title: 'Untitled checklist',
        items: [],
        type:0,
        value:false
      });

      this.setState({openCustomTemplate: true, sections: sections });
    };

    onEnterItemBtnClick = (sectionIndex) => {
      let { sections } = this.state;

      sections[sectionIndex].items.push({
        id: uuidv4(),
        content: 'Enter item'
      });

      this.setState({ sections: sections });
    };

    onRemoveItem = (sectionIndex, index) => {
      let { sections } = this.state;

      sections[sectionIndex].items.splice(index, 1);
      this.setState({ sections: sections});
    };

    onRemoveSection = (sectionIndex) => {
      let { sections } = this.state;

      sections.splice(sectionIndex, 1);
      this.setState({ sections: sections});
    };

    onEditTemplateTitle = (value) => {
      this.setState({name: value});
    }

    onEditDisclaimer = (value) => {
      this.state.disclaimer = value;
      this.setState({ disclaimer: this.state.disclaimer });
    }

    onEditSectionTitle = (index, value) => {
      let { sections } = this.state;

      sections[index].title = value;
      this.setState({ sections: sections });
    }

    onEditItemContent = (sectionIndex, index, value) => {
      let { sections } = this.state;

      sections[sectionIndex].items[index].content = value;
      this.setState({ sections: sections });
    }

    onClose= () => {
      this.props.onClose();
    }
    
  onChecked=(e, data) =>{
      let { sections} = this.state;
      if(sections.length > 0){
        var index = sections.findIndex((obj,index) => obj.id === sections[index].id);
        sections[index].value = !sections[index].value;

        if(!data){
          this.setState({openRFSSignoffConfirmModal: true, sections  });
        }else{
          this.setState({openRFSSignoffConfirmModal: false, sections });
        }
      }else{
        sections.push({
          id: uuidv4(),
          title: 'Are you sure you want to allow RFS SignOff without the WO being resolved or closed?',
          type: 1,
          value: true,
          items:[]
        });  
        if(!data){
          this.setState({openRFSSignoffConfirmModal: true, sections });
        }else{
          this.setState({openRFSSignoffConfirmModal: false, sections });
        }
        }
    }
    renderSections = () => {
      const { sections } = this.state;
      const { isSystemTemplate } = this.props;

      return (
        sections && sections.sort((a,b) => a.order - b.order).map((section, index) =>
        <div key={section.id} className='custom-template-section-item'>
            {section&&section.type === 0 &&
            <div className='top-section'>
              <div className='section-items'>
                <div className='col-xs-11' style={{top: '5px'}}>
               
                  <div className={isSystemTemplate ? 'default-template-name' : 'custom-template-name'}>
                    {
                      isSystemTemplate
                        ? <h5 style={{color: 'white', fontWeight: 'bolder'}} >{section.title}</h5>
                        : <input name={section.id} className='form-control custom-template-name' placeholder='Untitled checklist' autoComplete='off' maxLength='254' value={section.title}
                          onBlur={() => section.title || this.onEditSectionTitle(index, 'Untitled checklist') } onChange={ (e) => this.onEditSectionTitle(index, e.target.value) }/>
                    }
                  </div>
                </div>
                {
                  !isSystemTemplate &&
                  <div className='col-xs-1' style={{lineHeight: '46px', textAlign: 'center'}}>
                    <img src={delete_icon} style={{width: 20, cursor: 'pointer'}} onClick={() => this.onRemoveSection(index)}/>
                  </div>
                }
              </div>
              {this.renderSectionItems(section, index) }
              {
                !isSystemTemplate && 
                <div className='bottom-section'>
                  <div className='col-xs-12'>
                    <span onClick={() => this.onEnterItemBtnClick(index)}>Enter item</span>
                  </div>
                </div>
              }
            </div>
    }
              </div>
        )
      );
    }

    renderSectionItems = (section, sectionIndex) => {
      const { isSystemTemplate } = this.props;

      if (section.items && section.items.length === 0) {
        return '';
      }

      return (
        section.items&&section.items.sort((a, b) => a.order - b.order).map((item, index) =>
          <div key={item.id} className='bottom-section clearfix'>
            <div className='row item-bottom-section'>
              <div style={{ top: 5 }} className='col-xs-1'>
                <span>{index + 1}. </span>
              </div>
              <div className={isSystemTemplate ? 'default-content-items col-xs-9' : 'custom-content-items col-xs-9'}>
                {
                  isSystemTemplate
                    ? item.content
                    : <div className='item-section-edit'>
                      <textarea name={section.id + '|' + item.id} className='form-control' maxLength='254' value={item.content}
                        onChange={ (e) => this.onEditItemContent(sectionIndex, index, e.target.value) }/>
                    </div>
                }
              </div>
              {
                isSystemTemplate &&
                <div className='col-xs-1' style={{marginLeft: 25, top: '-6px', textAlign: 'center', left: 15}}>
                  <CheckBoxSingle
                    ref={c => { this.checkBox = c; }}
                    style={{ display: 'inline-block' }}
                    checked={item.approval}
                    disableClick={true} />
                </div>
              }
              {
                !isSystemTemplate &&
                <div className='col-xs-1' style={{ lineHeight: '36px' }}>
                  <img src={delete_icon} style={{width: 16, cursor: 'pointer'}} onClick={() => this.onRemoveItem(sectionIndex, index)}/>
                </div>
              }
            </div>
          </div>
        )
      );
    };

    render() {
      // const isInvalidTemplate = this.isInvalidTemplate();
      const { name, disclaimer, sections } = this.state;
      const { isSystemTemplate } = this.props;
      const isAllowRfsSignoff = sections.find((obj, index ) => obj.type === 1)
      console.log('isAllowRfsSignoff', isAllowRfsSignoff);
      return (
        <React.Fragment>
          <Modal centered='true' dialogClassName='template-eoc-dialog' show={true}>
            <div style={{ margin: 10 }}>
              <Modal.Header>
                <div className='container-fluid'>
                  <div className='title-custom-template row'>
                    {
                      isSystemTemplate
                        ? <h4 className='title' style={{ fontWeight: 'bolder', textTransform: 'uppercase', margin: 0}}>{name}</h4>
                        : <input name='model' className='form-control' placeholder='Untitled template' autoComplete='off' maxLength='254' value={name}
                          onBlur={() => name || this.onEditTemplateTitle('Untitled template') } onChange={(e) => this.onEditTemplateTitle(e.target.value)}/>
                    }
                  </div>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className='container-fluid'>
                {!isSystemTemplate &&
                <div className='row' style={{marginTop: '10px', marginBottom: '10px'}}>
                  <CheckBox
                    value={isAllowRfsSignoff ? isAllowRfsSignoff.value : false}
                    name='rfsSignoff'
                    className='siteone-checkbox margin-bottom-0 margin-top-0 pull-left'
                    handleChange={this.onChecked}
                    checked={isAllowRfsSignoff ? isAllowRfsSignoff.value : false}
                    label='Allow RFS Sign off Without resolving WO inside RFS'
                  />
               </div>
                }
                  {
                    !isSystemTemplate &&
                    <div className='row'>
                      <h5 style={{fontWeight: 'bolder', color: 'lightgray', marginLeft: 5}}>Checklist Configuration</h5>
                    </div>
                  }
                  <div className='row'>{ this.renderSections() }</div>
                  {
                    !isSystemTemplate &&
                      <div className='row'>
                        <button onClick={this.onAddNewSectionBtnClick} className='btn btn-primary btn-siteone-default'>
                          <span className='fa fa-plus icon' />Add new checklist</button>
                      </div>
                  }
                  <br/>
                  {
                    !isSystemTemplate
                      ? <div className='row'>
                        <h5 style={{fontWeight: 'bolder', color: 'lightgray'}}>Text Configuration</h5>
                        <div className='disclaimer'>
                          <span>Disclaimer <OverlayTrigger placement='right' overlay={this.toolTipDisclaimer()} delayHide={10} delayShow={500}><i className='fa fa-question-circle' /></OverlayTrigger></span>
                          <div className='disclaimer-textarea'>
                            <textarea className='form-control' name='disclaimer' ref='disclaimer' value={disclaimer} style={{height: 225}}
                              maxLength='524288' onChange={(e) => this.onEditDisclaimer(e.target.value)} />
                          </div>
                        </div>
                      </div>
                      : <div style={{marginLeft: 5, whiteSpace: 'pre-line'}} className='default-disclaimer-text'>{disclaimer}</div>
                  }
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className='row'>
                  <div className='col-xs-12' style={{ textAlign: 'left'}}>
                    {
                      isSystemTemplate
                        ? <button onClick={() => this.onClose()} className='btn btn-primary btn-siteone'>OK</button>
                        : <button onClick={this.onClose} className='btn btn-primary btn-siteone-default'>Cancel</button>
                    }
                    {
                      !isSystemTemplate &&
                      <button onClick={() => this.setState({ isSave: true, openConfirmModal: true })}
                        style={{ marginLeft: '20px' }} className='btn btn-primary btn-siteone' disabled={false}>Save</button>
                    }
                  </div>
                </div>
              </Modal.Footer>
              {
            this.state.openRFSSignoffConfirmModal && isAllowRfsSignoff && isAllowRfsSignoff.value&&
            <RFSSignoffModal
            isOpen={this.state.openRFSSignoffConfirmModal}
            onOk={this.onRFSSignoffConfirm}
            onCancel={this.onCancelConfirmModal}
            />
          }
              {
                this.state.openConfirmModal &&
                <ConfirmCancel
                  isSave={this.state.isSave}
                  isOpen={this.state.openConfirmModal}

                  data={{id: this.state.id, name: this.state.name, sections: this.state.sections, disclaimer: this.state.disclaimer,EofStatus: this.state.isAllowRfsSignoff  }}
                  templateId={this.props.templateId}

                  onOk={this.onClose}
                  onCancel={this.onCancelConfirmModal}
                  onEditCustomTemplate={this.props.onEditCustomTemplate}
                  onCloseAfterSave={this.onCloseAfterEdit}/>
              }
            </div>
          </Modal>
        </React.Fragment>
      );
    }
}

export default TemplateEOCView;



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-eoc-view.js